module.exports = __webpack_public_path__ + "static/assets/ebfac3f168323b5a72aa7562064b5e4c.png";